import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Head from '../components/Head';
import Foot from '../components/Foot';

const apiUrl = process.env.REACT_APP_API_URL;

function PhotoGallery() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/public/photo-gallery`);
        if (response.data.success) {
          setPhotos(response.data.photos);
        } else {
          setError(response.data.message || 'Failed to load photo gallery.');
        }
      } catch (err) {
        setError('Error fetching photo gallery. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchPhotos();
  }, []);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const showPrev = () => setPhotoIndex((i) => (i + photos.length - 1) % photos.length);
  const showNext = () => setPhotoIndex((i) => (i + 1) % photos.length);

  useEffect(() => {
    if (!isLightboxOpen) return undefined;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsLightboxOpen(false);
      else if (e.key === 'ArrowLeft') setPhotoIndex((i) => (i + photos.length - 1) % photos.length);
      else if (e.key === 'ArrowRight') setPhotoIndex((i) => (i + 1) % photos.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isLightboxOpen, photos.length]);

  return (
    <>
      <Head />
      {/* Start Hero */}
      <section className="common-page-hero">
        <img
          src="assets/img/bg/common-bg.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{ marginTop: 100 }}>
              <p className="ak-section-subtitle animation-title">Discover</p>
              <h2 className="ak-section-title animation-title">Photo Gallery</h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Discover / Photo Gallery
            </p>
          </div>
          <a href="" className="phone-number">
            +91 90486 48777
          </a>
        </div>
      </section>
      {/* End Hero */}
      <div className="ak-height-60 ak-height-lg-50" />
      <section>
        <div className="container">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {loading ? (
              <div className="col-12 text-center">Loading photo gallery...</div>
            ) : error ? (
              <div className="col-12 text-center text-danger">{error}</div>
            ) : photos.length === 0 ? (
              <div className="col-12 text-center text-warning">No photos found.</div>
            ) : (
              photos.map((photo, index) => (
                <div className="col" key={photo.id}>
                  <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
                    <div
                      className="image-thumbnail cursor-pointer"
                      onClick={() => openLightbox(index)}
                    >
                      <img
                        src={`${apiUrl}/${photo.image_path}`}
                        alt={photo.title || 'Gallery photo'}
                        className="w-full h-64 object-cover"
                      />
                      <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                        <span className="text-white font-semibold">View Image</span>
                      </div>
                    </div>
                    {photo.title && (
                      <div className="p-4">
                        <h5 className="text-lg font-semibold">{photo.title}</h5>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
      <div className="ak-height-20 ak-height-lg-30" />
      <Foot />

      {isLightboxOpen && photos[photoIndex] && (
        <div
          onClick={closeLightbox}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 2000,
            background: 'rgba(0,0,0,0.9)', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
        >
          <button
            type="button"
            onClick={closeLightbox}
            aria-label="Close"
            style={{
              position: 'absolute', top: 20, right: 24, background: 'transparent', border: 'none',
              color: '#fff', fontSize: 32, lineHeight: 1, cursor: 'pointer', zIndex: 2001,
            }}
          >
            &times;
          </button>

          {photos.length > 1 && (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); showPrev(); }}
              aria-label="Previous"
              style={{
                position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)',
                background: 'transparent', border: 'none', color: '#fff', fontSize: 40,
                lineHeight: 1, cursor: 'pointer', zIndex: 2001,
              }}
            >
              &#8249;
            </button>
          )}

          <img
            src={`${apiUrl}/${photos[photoIndex].image_path}`}
            alt={photos[photoIndex].title || 'Gallery photo'}
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '90vw', maxHeight: '80vh', objectFit: 'contain', borderRadius: 4 }}
          />

          {photos.length > 1 && (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); showNext(); }}
              aria-label="Next"
              style={{
                position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)',
                background: 'transparent', border: 'none', color: '#fff', fontSize: 40,
                lineHeight: 1, cursor: 'pointer', zIndex: 2001,
              }}
            >
              &#8250;
            </button>
          )}

          {photos[photoIndex].title && (
            <div style={{ color: '#fff', marginTop: 16, fontSize: 16, textAlign: 'center' }}>
              {photos[photoIndex].title}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default PhotoGallery;
